import { scroll } from '../utils/scroll.js';

export const menu = {
    header: null,
    button: null,
    dropdown: null,
    openers: [],
    isOpen: false,
    activeSubmenu: null,

    init() {
        this.header = document.querySelector('.b-header')
        this.button = document.querySelector('.js-header-menu')
        this.dropdown = document.querySelector('.js-header-dropdown')
        this.openers = document.querySelectorAll('.js-menu-open')

        if (!this.header || !this.button || !this.dropdown || !this.openers.length) return

        document.documentElement.style.setProperty('--dropdown-height', '0px')

        this.button.addEventListener('click', () => this.toggleMenu())
        this.openers.forEach((btn) => {
            const opener = btn.nextElementSibling
            btn.addEventListener('mouseenter', () => this.toggleMenu(opener))
            opener.addEventListener('mouseleave', () => this.closeMenu(opener))
        })
        window.addEventListener('resize', () => this.onResize())

        this.initSubmenus()
    },

    initSubmenus() {
        const submenuButtons = this.dropdown.querySelectorAll('.js-menu-submenu')
        const closeButtons = this.dropdown.querySelectorAll('.js-submenu-close')

        submenuButtons.forEach((btn) => {
            btn.addEventListener('click', () => {
                const parentItem = btn.closest('.b-menu-dropdown__item')
                const submenu = parentItem.querySelector('.b-menu-dropdown__submenu')
                if (submenu) this.openSubmenu(submenu)
            })
        })

        closeButtons.forEach((btn) => {
            btn.addEventListener('click', () => this.closeSubmenu())
        })
    },

    openSubmenu(submenu) {
        // Si hay un submenú abierto, lo ocultamos
        if (this.activeSubmenu && this.activeSubmenu !== submenu) {
            this.activeSubmenu.style.opacity = '0'
            this.activeSubmenu.style.display = 'none'
        }

        submenu.style.display = 'block'

        requestAnimationFrame(() => {
            submenu.style.opacity = '1'
            this.updateDropdownHeight(submenu)
        })

        this.activeSubmenu = submenu
    },

    closeSubmenu() {
        if (!this.activeSubmenu) return

        const current = this.activeSubmenu
        current.style.opacity = '0'

        const onEnd = (e) => {
            if (e.propertyName !== 'opacity') return
            current.style.display = 'none'
            current.removeEventListener('transitionend', onEnd)
        }

        current.addEventListener('transitionend', onEnd)
        this.activeSubmenu = null

        // Volver a la altura del dropdown principal
        this.updateDropdownHeight(this.dropdown.querySelector('.b-menu-dropdown'))
    },

    onResize() {
        if (this.isOpen) {
            this.updateDropdownHeight(this.activeSubmenu || this.dropdown.querySelector('.b-menu-dropdown'))
        } else {
            document.documentElement.style.setProperty('--dropdown-height', '0px')
        }
    },

    updateDropdownHeight(target) {
        if (!target) return
        const clone = target.cloneNode(true)
        clone.style.visibility = 'hidden'
        clone.style.position = 'absolute'
        clone.style.left = '-99999px'
        clone.style.top = '0'
        clone.style.height = 'auto'
        clone.style.maxHeight = 'none'
        clone.style.opacity = '0'

        document.body.appendChild(clone)
        const height = clone.scrollHeight
        document.body.removeChild(clone)

        document.documentElement.style.setProperty('--dropdown-height', `${height}px`)
        return height
    },

    openMenu(opener) {
        if (!opener) {
            opener = this.dropdown.querySelector('.b-menu-dropdown')
        }
        this.updateDropdownHeight(opener)
        this.header.classList.add('is-open')
        this.isOpen = true
        if (scroll.lenis) scroll.lenis.stop()
    },

    closeMenu(closer) {
        if (!closer) {
            closer = this.dropdown;
        }

        document.documentElement.style.setProperty('--dropdown-height', '0px')

        const onEnd = (e) => {
            if (e.propertyName !== 'height') return
            this.header.classList.remove('is-open')
            closer.removeEventListener('transitionend', onEnd)
        }

        closer.addEventListener('transitionend', onEnd)
        this.isOpen = false
        if (scroll.lenis) scroll.lenis.start()
    },

    toggleMenu(opener) {
        this.isOpen ? this.closeMenu() : this.openMenu(opener)
    },
}
